import { get as get_store } from "svelte/store";
import { hooksStore } from "../../stores/hooks.store";
import { tempStore } from "../../stores/temp.store";
import { configStore } from "../../stores/config.store";
import { userStore } from "../../stores/user.store.js";

import { getMap } from "../../helpers/map";
import {
  ulozStavDoPamate,
  ziskajStavUzivatela,
  currentUserId,
} from "../../stores/user.store.js";
import get from "get-value";
import set from "set-value";

/**
 * Horne menu
 */
if (hooksStore.hasFilter("sidebarMenuTop", "zobrazit_celu_mapu") === false) {
  hooksStore.addFilter(
    "sidebarMenuTop",
    "zobrazit_celu_mapu",
    (menuList) => {
      menuList.push({
        nazov: "Zobraziť celú mapu",
        icon: "015",
        callback: () => {
          const map = getMap();
          map.flyTo({
            center: [
              get(get_store(configStore), "pociatocne_pozicie.lng"),
              get(get_store(configStore), "pociatocne_pozicie.lat"),
            ],
            zoom: get(get_store(configStore), "pociatocne_pozicie.zoom"),
          });
        },
      });

      return menuList;
    },
    10
  );
}

if (hooksStore.hasFilter("sidebarMenuTop", "vycistit_celu_mapu") === false) {
  hooksStore.addFilter(
    "sidebarMenuTop",
    "vycistit_celu_mapu",
    (menuList) => {
      menuList.push({
        nazov: "Vyčistiť celú mapu",
        icon: "016",
        callback: () => {
          const map = getMap();
          const u = userStore.getUser();
          // prechadzam vsetky layery, nie sources, lebo najprv treba vymazat layer
          map.getStyle().layers.forEach(function (layer) {
            if (
              ["sm_", "meranie_"].some((prefix) =>
                layer.source.startsWith(prefix)
              )
            ) {
              map.removeLayer(layer.id);
            }
          });
          // ak existuje source ktory mam vymazat
          for (const source_id in map.getStyle().sources) {
            if (
              ["sm_", "meranie_"].some((prefix) => source_id.startsWith(prefix))
            ) {
              map.removeSource(source_id);
            }
          }
          // zmazem informaciu aj z pamate stavu uzivatela
          set(u, "options.mapa.stav", {});
          userStore.updateUser(u);
          hooksStore.doAction("zmazatVsetkyPopupOkna");
        },
      });

      return menuList;
    },
    20
  );
}

/**
 * Spodne menu
 */
if (hooksStore.hasFilter("sidebarMenuBottom", "Odhlasit_sa") === false) {
  hooksStore.addFilter(
    "sidebarMenuBottom",
    "Odhlasit_sa",
    (menuList) => {
      menuList.push({
        nazov: "Odhlásiť sa",
        icon: "022",
        callback: () => logoutFunction(),
      });

      return menuList;
    },
    90
  );
}

/**
 * Komponenty
 */
// if (hooksStore.hasFilter("sidebarMenuComponents", "Zmenit_vrstvy") === false) {
hooksStore.addFilter(
  "sidebarMenuComponents",
  "Zmenit_vrstvy",
  (components) => {
    // pridanie ikonky do menu
    if (hooksStore.hasFilter("sidebarMenuTop", "Zmenit_vrstvy") === false) {
      hooksStore.addFilter(
        "sidebarMenuTop",
        "Zmenit_vrstvy",
        (menuList) => {
          menuList.push({
            nazov: "Zmeniť vrstvy",
            icon: "017",
            callback: () => {
              viditelnostTabu("vrstvy");
            },
          });

          return menuList;
        },
        20
      );
    }

    // vratenie komponentu
    const component = () => import("./sidebar/Vrstvy.svelte");
    components.push(component);
    return components;
  },
  10
);
// }

hooksStore.addFilter(
  "sidebarMenuComponents",
  "legenda",
  (components) => {
    // pridanie ikonky do menu
    if (hooksStore.hasFilter("sidebarMenuTop", "legenda") === false) {
      hooksStore.addFilter(
        "sidebarMenuTop",
        "legenda",
        (menuList) => {
          menuList.push({
            nazov: "Legenda",
            icon: "045",
            callback: () => {
              viditelnostTabu("legenda");
            },
          });

          return menuList;
        },
        20
      );
    }

    // vratenie komponentu
    const component = () => import("./sidebar/Legenda.svelte");
    components.push(component);
    return components;
  },
  20
);

hooksStore.addFilter(
  "sidebarMenuComponents",
  "fnc",
  (components) => {
    // pridanie ikonky do menu
    if (
      hooksStore.hasFilter("sidebarMenuTop", "meranie_vzdialenosti") === false
    ) {
      hooksStore.addFilter(
        "sidebarMenuTop",
        "meranie_vzdialenosti",
        (menuList) => {
          menuList.push({
            nazov: "Meranie vzdialenosti",
            icon: "019",
            callback: () => {
              viditelnostTabu("meranieVzdialenosti");
            },
          });

          return menuList;
        },
        20
      );
    }

    // vratenie komponentu
    const component = () => import("./sidebar/Meranie.svelte");
    components.push(component);
    return components;
  },
  30
);

hooksStore.addFilter(
  "sidebarMenuComponents",
  "poznamky",
  (components) => {
    // pridanie ikonky do menu
    if (hooksStore.hasFilter("sidebarMenuTop", "poznamky") === false) {
      hooksStore.addFilter(
        "sidebarMenuTop",
        "poznamky",
        (menuList) => {
          menuList.push({
            nazov: "Poznámky",
            icon: "020",
            callback: () => {
              viditelnostTabu("poznamky");
            },
          });

          return menuList;
        },
        30
      );
    }

    // vratenie komponentu
    const component = () => import("./sidebar/Poznamky.svelte");
    components.push(component);
    return components;
  },
  40
);

hooksStore.addFilter(
  "sidebarMenuComponents",
  "systemove_informacie",
  (components) => {
    // pridanie ikonky do menu
    if (
      hooksStore.hasFilter("sidebarMenuBottom", "systemove_informacie") ===
      false
    ) {
      hooksStore.addFilter(
        "sidebarMenuBottom",
        "systemove_informacie",
        (menuList) => {
          menuList.push({
            nazov: "Systémové informácie",
            icon: "018",
            callback: () => {
              viditelnostTabu("systemoveInfo");
            },
          });

          return menuList;
        },
        80
      );
    }

    // vratenie komponentu
    const component = () => import("./sidebar/SystemoveInfo.svelte");
    components.push(component);
    return components;
  },
  10
);

hooksStore.addFilter(
  "sidebarMenuComponents",
  "nastavenia_uctu",
  (components) => {
    // pridanie ikonky do menu
    if (
      hooksStore.hasFilter("sidebarMenuBottom", "nastavenia_uctu") === false
    ) {
      hooksStore.addFilter(
        "sidebarMenuBottom",
        "nastavenia_uctu",
        (menuList) => {
          menuList.push({
            nazov: "Nastavenia účtu",
            icon: "021",
            callback: () => {
              viditelnostTabu("nastaveniaUctu");
            },
          });

          return menuList;
        },
        80
      );
    }

    // vratenie komponentu
    const component = () => import("./sidebar/NastaveniaUctu.svelte");
    components.push(component);
    return components;
  },
  10
);

/**
 * Funkcie
 */
async function logoutFunction() {
  // pred odhlasenim z api ulozim aktualny stav aj do api
  let stav = await ziskajStavUzivatela(get_store(currentUserId));
  if (stav) {
    await ulozStavDoPamate(stav);
  }
  // odhlasenie z api a presmerovanie na uvod
  hooksStore.doAction("odhlasitUzivatela");
  history.pushState(
    "",
    document.title,
    window.location.pathname + window.location.search
  );
}

export function viditelnostTabu(typ, open = false) {
  let store = get_store(tempStore);
  let menu = get(store, "menu");
  if (open) {
    menu = typ;
  } else {
    menu = menu === typ ? null : typ;
  }
  set(store, "menu", menu);
  tempStore.set(store);
}
